import React from 'react';
import { CardSize, CardNavigation, ColorVariant } from '@naf/cards';
import { NavCardLink } from '../../../../components/styled-link/StyledLink';
import { CenterProductsType } from '../../../../../../types/centerProductsType';
import S from '../styles';

export const ProductCard = ({
  product,
  path,
  isAvailable,
  alternateBackgroundColor,
}: {
  product: CenterProductsType;
  path: string;
  isAvailable: boolean;
  alternateBackgroundColor: boolean;
}) => (
  <>
    {isAvailable && product.isAvailable && product.link && (
      <S.ShortCutCol s="12" m="6" l="4" xl="4">
        <NavCardLink to={`${path}/${product.link.data.slug}`}>
          <CardNavigation
            title={product.title}
            size={CardSize.Medium}
            isInternalLink
            height="100%"
            colorVariant={alternateBackgroundColor ? ColorVariant.Secondary : ColorVariant.Outline}
          >
            {product.isCampaign && <S.StyledLabel variant="moss" text="Kampanje" />}
            {product.isForMembersOnly && <S.StyledLabel variant="signature" text="Medlemseksklusivt" />}
            {product.ingress}
          </CardNavigation>
        </NavCardLink>
      </S.ShortCutCol>
    )}
    {!isAvailable && !product.isAvailable && (
      <S.ShortCutCol s="12" m="6" l="4" xl="4">
        <CardNavigation
          disabled
          title={product.title}
          size={CardSize.Medium}
          height="100%"
          colorVariant={alternateBackgroundColor ? ColorVariant.Secondary : ColorVariant.Outline}
        >
          {product.ingress}
        </CardNavigation>
      </S.ShortCutCol>
    )}
  </>
);
